export const FETCH_ALL_PROGRAMS = 'FETCH_ALL_PROGRAMS'
export const FETCH_PROGRAM = 'FETCH_PROGRAM'

export const FETCH_REGISTERED_PROGRAM = 'FETCH_REGISTERED_PROGRAM'
export const FETCH_ALL_APPLICANT_REGISTERED_PROGRAMS = 'FETCH_ALL_APPLICANT_REGISTERED_PROGRAMS'